import React, { useState, useRef, useEffect } from 'react';
import { useDropdownClose } from '../../hooks/useDropdownClose';
import { Hinweis } from '../../icons';
import './TooltipIcon.css';

export function TooltipIcon({ text, idSuffix }) {
  const [show, setShow] = useState(false);
  const tooltipRef = useRef(null);
  const btnRef = useRef(null);
  useDropdownClose(show, () => setShow(false), `.tooltip-trigger-${idSuffix}`);

  useEffect(() => {
    if (!show) return;
    const tooltipEl = tooltipRef.current;
    const btnEl = btnRef.current;
    if (!tooltipEl || !btnEl) return;

    function positionTooltip() {
      const winW = window.innerWidth;
      const margin = 16;
      const btnRect = btnEl.getBoundingClientRect();
      const wrapperEl = btnEl.closest('.card-wrapper-large');
      const refRect = wrapperEl ? wrapperEl.getBoundingClientRect() : btnRect;
      const tooltipW = Math.min(462, Math.max(160, winW - 32));
      let left = Math.round(refRect.left + refRect.width / 2 - tooltipW / 2);
      if (left < margin) left = margin;
      if (left + tooltipW > winW - margin) left = winW - margin - tooltipW;
      tooltipEl.style.position = 'fixed';
      tooltipEl.style.top = `${Math.round(btnRect.bottom)}px`;
      tooltipEl.style.left = `${left}px`;
      tooltipEl.style.width = `${tooltipW}px`;
      tooltipEl.style.right = 'auto';
      tooltipEl.style.transform = 'none';
    }

    positionTooltip();
    window.addEventListener('resize', positionTooltip);
    window.addEventListener('scroll', positionTooltip, true);
    return () => {
      window.removeEventListener('resize', positionTooltip);
      window.removeEventListener('scroll', positionTooltip, true);
    };
  }, [show]);

  return (
    <span className={`tooltip-trigger-wrapper tooltip-trigger-${idSuffix}`}>
      <button
        ref={btnRef}
        type="button"
        className={`tooltip-icon-button${show ? ' active' : ''}`}
        aria-label="Information"
        title="Information anzeigen"
        aria-describedby={show ? `tooltip-${idSuffix}` : undefined}
        aria-expanded={show}
        onClick={() => setShow(prev => !prev)}
        onKeyDown={e => { if (e.key === 'Escape') setShow(false); }}
      >
        <Hinweis />
      </button>
      {show && (
        <div id={`tooltip-${idSuffix}`} role="tooltip" ref={tooltipRef} className="custom-tooltip">
          {text}
        </div>
      )}
    </span>
  );
}
